import { useState, useContext } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import _get from 'lodash/get';

import { User } from 'commons/models/marketingDashboard';
import { AppContext } from 'commons-ui';
import useService from '../../utils/useService';
import { FORM_FIELD_CONFIG, FORM_FIELD_KEYS } from '../../helper';

const useEdit = () => {
	const [showLoader, setShowLoader] = useState(false);
	const history = useHistory();
	const { showAlert, app } = useContext(AppContext);
	const { requestUpdateUser, getRoleOptions } = useService();

	const location = useLocation();
	const data = _get(location, ['state', 'rowData']);
	FORM_FIELD_CONFIG[FORM_FIELD_KEYS.ROLE_ID].setRenderProps({ getOptions: getRoleOptions });

	const updateUser = async (updatedData: User) => {
		setShowLoader(true);
		try {
			await requestUpdateUser(app.appName, updatedData);
		} catch (e: any) {
			showAlert(e.response?.data?.error ?? 'Error while editing this user', { type: 'error' });
			setShowLoader(false);

			history.goBack();
		}
		showAlert('User edited successfully', { type: 'success' });
		setShowLoader(false);

		history.goBack();
	};

	const handleFormSubmit = (submittedData: User) => {
		updateUser(submittedData);
	};

	const handleFormCancel = () => {
		history.goBack();
	};

	return { data, showLoader, handleFormSubmit, handleFormCancel, setShowLoader };
};

export default useEdit;
